import React__default from 'react';
import { ThemeProvider as ThemeProvider$1, useTheme as useTheme$1 } from '@emotion/react';
import { ModalProvider } from '../components/Modal/context.es.js';
import { ToastProviderDesktop } from '../components/Toast/desktop/context.es.js';
import { ToastProviderMobile } from '../components/Toast/mobile/context.es.js';
import { defaultTheme } from '../configs/Theme/index.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ThemeProvider = (_a) => {
  var _b = _a, {
    children,
    theme = defaultTheme,
    customTheme
  } = _b, rest = __objRest(_b, [
    "children",
    "theme",
    "customTheme"
  ]);
  return /* @__PURE__ */ React__default.createElement(ThemeProvider$1, __spreadValues({
    theme: __spreadValues(__spreadValues({}, theme), customTheme)
  }, rest), /* @__PURE__ */ React__default.createElement(ModalProvider, null, /* @__PURE__ */ React__default.createElement(ToastProviderDesktop, null, /* @__PURE__ */ React__default.createElement(ToastProviderMobile, null, children))));
};
function useTheme() {
  const theme = useTheme$1();
  return theme;
}

export { ThemeProvider, useTheme };
